import './styles/@theme';
import { OptInButtonClient } from './opt-in-button.client';

export const OptInButton = OptInButtonClient;
